module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9Im9jdGFnb24iIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+Cgk8ZGVzYz5vY3RhZ29uPC9kZXNjPgoJPHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiCgkJZD0iTTAsMjUgTDI1LDAgTDc1LDAgTDEwMCwyNSBMMTAwLDc1IEw3NSwxMDAgTDI1LDEwMCBMMCw3NSBaIi8+CiAgICA8L3N5bWJvbD4KICA8L2RlZnM+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/icons/octagon.svg
// module id = 705
// module chunks = 0